/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AnalyticsConfig } from '../model';
/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets analytics config
         * @summary Gets analytics config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalyticsConfig: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets analytics config
         * @summary Gets analytics config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalyticsConfig(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticsConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalyticsConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsApiFp(configuration)
    return {
        /**
         * Gets analytics config
         * @summary Gets analytics config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalyticsConfig(options?: any): AxiosPromise<AnalyticsConfig> {
            return localVarFp.getAnalyticsConfig(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
    /**
     * Gets analytics config
     * @summary Gets analytics config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public getAnalyticsConfig(options?: any) {
        return AnalyticsApiFp(this.configuration).getAnalyticsConfig(options).then((request) => request(this.axios, this.basePath));
    }
}
